import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const GlassCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: "20px",
  background: "rgba(255, 255, 255, 0.15)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(15px)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
  maxWidth: "500px",
  margin: "auto",
}));

export default function App() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email.includes("@")) {
      alert("Please fill out name and valid email.");
      return;
    }
    setOpen(true);
  };

  return (
    <Container>
      <GlassCard elevation={0}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ color: "white", fontWeight: "bold" }}
        >
          My city hub
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{ mb: 3, color: "white" }}
        >
          Submit a request to delete your account and data
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="User Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
            InputProps={{
              style: { backgroundColor: "white", borderRadius: 10 },
            }}
          />

          <TextField
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
            InputProps={{
              style: { backgroundColor: "white", borderRadius: 10 },
            }}
          />

          <TextField
            label="Comment"
            name="comment"
            multiline
            rows={3}
            value={form.comment}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            InputProps={{
              style: { backgroundColor: "white", borderRadius: 10 },
            }}
          />

          <Button
            type="submit"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              borderRadius: 3,
              background: "linear-gradient(135deg, #6A11CB, #2575FC)",
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              "&:hover": {
                background: "linear-gradient(135deg, #2575FC, #6A11CB)",
              },
            }}
          >
            Submit Request
          </Button>
        </Box>
      </GlassCard>

      {/* Dialog Popup */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>✅ Request Submitted</DialogTitle>
        <DialogContent>
          <Typography>
            Within 2 days your account will be deleted.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}